const TZ = 'America/Santo_Domingo';

const DATE_OPTS: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: TZ,
};

export const formatDate = (val: string | null | undefined): string => {
    if (!val) return '—';
    return new Date(val).toLocaleDateString('es-ES', DATE_OPTS);
};

export const formatDateTime = (val: string | null | undefined): string => {
    if (!val) return '—';
    return new Date(val).toLocaleDateString('es-ES', DATE_OPTS);
};
